module.exports = __webpack_public_path__ + "static/media/mkv.cd8e2a18.png";